exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-bc .field-group .field-label {\r\n    width: 140px;\r\n}\r\n\r\n.view-bc .field-group .form-control {\r\n    width: calc(100% - 185px);\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/Projects/view-BC.css
// module id = 435
// module chunks = 0